var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 10C12.5002 8.35 11.1502 7 9.50023 7C7.85023 7 6.50023 8.35 6.50023 10C6.50023 11.65 7.85023 13 9.50023 13C11.1502 13 12.5002 11.65 12.5002 10ZM9.50023 11C8.95023 11 8.50023 10.55 8.50023 10C8.50023 9.45 8.95023 9 9.50023 9C10.0502 9 10.5002 9.45 10.5002 10C10.5002 10.55 10.0502 11 9.50023 11ZM16.0002 13C17.1102 13 18.0002 12.11 18.0002 11C18.0002 9.89 17.1102 9 16.0002 9C14.8902 9 13.9902 9.89 14.0002 11C14.0002 12.11 14.8902 13 16.0002 13ZM11.9902 2.01C6.47023 2.01 1.99023 6.49 1.99023 12.01C1.99023 17.53 6.47023 22.01 11.9902 22.01C17.5102 22.01 21.9902 17.53 21.9902 12.01C21.9902 6.49 17.5102 2.01 11.9902 2.01ZM5.84023 17.12C6.52023 16.58 8.11023 16.01 9.50023 16.01C9.57023 16.01 9.65023 16.02 9.73023 16.02C9.97023 15.38 10.4002 14.73 11.0302 14.16C10.4702 14.06 9.94023 14 9.50023 14C8.20023 14 6.11023 14.45 4.77023 15.43C4.27023 14.39 3.99023 13.23 3.99023 12C3.99023 7.59 7.58023 4 11.9902 4C16.4002 4 19.9902 7.59 19.9902 12C19.9902 13.2 19.7202 14.34 19.2402 15.37C18.2402 14.78 16.8802 14.5 16.0002 14.5C14.4802 14.5 11.5002 15.31 11.5002 17.2V19.98C9.23023 19.85 7.21023 18.77 5.84023 17.12Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.af891441c6244008d669d60417d5956a.svg";
export { ForwardRef as ReactComponent };